module.exports = __webpack_public_path__ + "img/archive.04f57f22.png";